//アンカーリンク用
var SmoothScroll = require('./functions/smoothscroll.js');
//最も高い要素に合わせる用
var AdjustHeight = require('./functions/adjustHeight.js');
//画面幅・高さに合わせて各種調整用
var HeightVisual = require('./functions/heightVisual.js');
// console.log('first');
$(document).on('ready', function(){
    // console.log("ready");
    $(window).on('load',function() {
        SmoothScroll.init("",".fn-header");
        AdjustHeight.init("",".main-value .header");
        HeightVisual.init("");
    });

    $(window).on('resize',function() {
        // SmoothScroll.init("",".fn-header");
        // console.log("resize");
        AdjustHeight.init("",".main-value .header");
        HeightVisual.init("");
    });

    //アコーディオン(QA)
    $("#question .qa-box .type-q").on("click", function(){
        $(this).next().slideToggle(200);
    });

    $("#question .qa-box .close").on("click", function(){
        $(this).parent().slideUp(200);
    });

    $(window).on('scroll',function() {
        var scl_top = 100;
        // console.log($(this).scrollTop());
        if($(this).scrollTop() > scl_top) {
            $('.fn-icon-down').removeClass('off').addClass('on');
        }else {
            $('.fn-icon-down').removeClass('on').addClass('off');
        }
        
    });
});